export default "__VITE_ASSET__vwT_359V__"